/**
 * This doc is a central location for different constants or enums that are
 * relevant at different locations of the website codebase in order to
 * maintain consistency.
 */

// The different markings allowed on the label
const CYCLE_STEPS = []
// 05 min steps from 5 to 55 min
for (let min = 5; min < 60; min += 5) CYCLE_STEPS.push({ value: min })
// 30 min steps from 1 hour to 11.5 hours
for (let hour = 1; hour < 12; hour += 0.5) CYCLE_STEPS.push({ value: hour * 60 })
// 60 min steps from 12 hours to 48 hours
for (let hour = 12; hour <= 48; hour += 1) CYCLE_STEPS.push({ value: hour * 60 })

// The different markings allowed on the label
const SYNC_STEPS = []
// 05 min steps from 5 to 55 min
for (let min = 5; min < 60; min += 5) SYNC_STEPS.push({ value: min })
// 30 min steps from 1 hour to 11.5 hours
for (let hour = 1; hour < 12; hour += 0.5) SYNC_STEPS.push({ value: hour * 60 })
// 60 min steps from 12 hours to 48 hours
for (let hour = 12; hour <= 48; hour += 1) SYNC_STEPS.push({ value: hour * 60 })

/**
 * The text to diplay for the No Group Option
 */
const NO_GROUP_TEXT = "No Group"

const MINIMUM_BATTERY_VOLTAGE = 3.2

/**
 * The names for each page in the webpage
 * @enum {string}
 */
const Page = {
  USER_INSIGHTS: "userInsights",
  DASHBOARD: "dashboard",
  DEVICE: "device",
  ACCOUNT: "account",
  MODELS: "models",
  MAP: "map",
  MARKETPLACE: "marketplace",
  DOCUMENTATION: "documentation",
  ADMIN: "admin",
  GROUPS: "groups",
  INTERNAL: "internal",
  DEVICE_UPDATES: "deviceUpdates",
  ALERTS: "alerts",
  OTA_MESSAGES: "otaMessages",
}

const IntegrationPlatforms = {
  GUNDI: "gundi",
  GUNDI_V2: "gundi_v2",
  EMAIL: "email",
}

const NotificationConstants = {
  ALL: "all",
  NONE: "none",
}

const AlertSettings = {
  ENABLED: "enabled",
  DISABLED: "disabled",
}

const DigestSettings = {
  DAILY: "daily",
}

const DeviceHeaders = {
  DEVICE_NAME: "Device Name",
  STATUS: "Status",
  LOCATION: "Location",
  RELEASE: "Release",
  LAST_SEEN: "Last Seen",
  TIME_ZONE: "Time Zone",
  LATITUDE: "Latitude",
  LONGITUDE: "Longitude",
  MEMORY: "Memory Remaining",
  DEPLOYED_MODELS: "Deployed Models",
  GROUP: "Group",
  DETAILS: "Details",
  EDIT: "Edit",
  DESCRIPTION: "Description",
  LOCATION_DESCRIPTION: "Location Description",
}

const BulkUpdateStatus = {
  PROCESSING: 1,
  COMPLETED: 2,
  WAITING: 3,
  BLOCKED: 4,
}

const ActionsRanking = {
  FIRST: "acknowledge",
  SECOND: null,
  THIRD: "favorite",
  FOURTH: "archive",
}

const DEVICE_UPDATE_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
  PENDING: "pending",
  DROPPED: "dropped",
  PENDING_RESET: "pending_reset",
}

const IMAGE_NORMALIZAION_METHODS = {
  RESIZE: "resize",
  PADDING: "padding",
}

const FEATURES = {
  COLLECTIONS: "insight_collections",
  OTA_MESSAGES_EXPERIMENTAL: "ota_messages_experimental",
}

const USER_ALERT_STATUS = {
  NEW: "new",
  ACKNOWLEDGED: "acknowledged",
  RESOLVED: "resolved",
}

const INSIGHT_STATUS = {
  FAVORITE: "favorite",
  ACKNOWLEDGE: "acknowledge",
  ARCHIVE: "archive",
  UNCATEGORIZED: "uncategorized",
}

const CACHE_STATUS = {
  GOOD: "good",
  STALE: "stale",
}

const USER_ALERT_KEYS = {
  DEVICE_ID: "Device ID",
}

const OTA_MESSAGE_TYPES = {
  RESET_DEVICE: "reset_device",
  UPDATE_MODEL_SETTINGS: "update_model_settings",
  UPDATE_SETTINGS: "update_state",
  REQUEST_HIGH_RES: "request_higher_res_image",
}

const USER_ALERT_TYPES = {
  SPYPOINT_ERROR: "spypoint_error",
  LOW_BATTERY: "low_battery",
  NO_RECENT_INSIGHTS: "no_recent_insights",
  NO_RECENT_CAMERA_TRIGGERS: "no_recent_camera_triggers",
}

const WIDGETS = {
  TOTAL_INSIGHTS: "total_insights",
  INSIGHT_BY_HOUR_OF_DAY: "insight_by_hour_of_day",
  DEVICE_HOURS_SINCE_TABLE: "device_hours_since_table",
  DEVICE_HOURS_SINCE_GRAPH: "device_hours_since_graph",
  DEVICE_HEATMAP: "device_heatmap",
  INSIGHT_COMMS_SOURCE: "insight_comms_source",
  INSIGHT_DELAY: "insight_delay",
  INSIGHTS_BY_CLASS: "insights_by_class",
  INSIGHTS_OVER_2_WEEKS: "insights_over_2_weeks",
  INSIGHT_STATUSES: "insight_statuses",
  TOTAL_CLASSES: "total_classes",
  TOTAL_DEVICES: "total_devices",
  INSIGHTS_VS_IMAGES: "insights_vs_images",
}

const GRID_STEPS = 12

export {
  OTA_MESSAGE_TYPES,
  WIDGETS,
  GRID_STEPS,
  INSIGHT_STATUS,
  USER_ALERT_TYPES,
  USER_ALERT_KEYS,
  USER_ALERT_STATUS,
  MINIMUM_BATTERY_VOLTAGE,
  DEVICE_UPDATE_STATUS,
  CYCLE_STEPS,
  SYNC_STEPS,
  NO_GROUP_TEXT,
  Page,
  IntegrationPlatforms,
  NotificationConstants,
  AlertSettings,
  DigestSettings,
  DeviceHeaders,
  BulkUpdateStatus,
  ActionsRanking,
  IMAGE_NORMALIZAION_METHODS,
  FEATURES,
  CACHE_STATUS,
}
